import { type HeaderContentProps } from '~/utils'

export const DefaultHeaderContent = (_props: HeaderContentProps) => null
